import { AppSidebar } from '@/components/app-sidebar'
import { SidebarInset, SidebarProvider, SidebarTrigger, useSidebar } from '@/components/ui/sidebar'

export default function Layout({ children }: { children: React.ReactNode }) {
  return (
    <SidebarProvider>
      <a href="#main-content" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded-md focus:bg-background focus:p-3 focus:text-foreground focus:shadow-md">
        Saltar al contenido
      </a>
      <AppSidebar />
      <SidebarInset className="min-w-0 bg-background">
        <main id="main-content" tabIndex={-1} className="min-w-0 flex-1 scroll-mt-16 p-4 focus-visible:outline-2 focus-visible:outline-ring sm:p-6 lg:p-8">
          {/* Shared gutters and centering for every workspace page. Forms and
              profiles may use a narrower centered width inside this boundary. */}
          <div className="mx-auto w-full min-w-0 max-w-[1400px]">
            <MenuAccess />
            {children}
          </div>
        </main>
      </SidebarInset>
    </SidebarProvider>
  )
}

function MenuAccess() {
  const { isMobile, open } = useSidebar()
  if (!isMobile && open) return null
  return (
    <div className="mb-3">
      <SidebarTrigger aria-label="Abrir menú" />
    </div>
  )
}
